var app = {
	header: {
		build: "Build",
		closeButton: "Stäng",
		copyrightLabel: "Upphovsrätt",
		helpLabel: "Hjälp",
		legalNoticeLabel: "Juridiskt meddelande",
		logoutButton: "Logga ut",
		menuLabel: "Meny",
		module: "Modul",
		noUserDataLabel: "Ingen användardata tillgänglig",
		notificationsLabel: "Notifieringar",
		privacyPolicyLabel: "Integritetspolicy",
		serviceAppLabel: "Service-app",
		settingsLabel: "Inställningar",
		shopLabel: "Butik",
		smartFactorySuiteLabel: "Smart-Factory Suite",
		softwareInformation: "Programvaruinformation",
		userLabel: "Profil",
		userProfileLinkText: "Användarprofil",
		version: "Version"
	}
};
var contentLoadingError = "Innehållet kunde inte laddas";
var dashboard = {
	cancel: {
		button: "Avbryt"
	},
	edit: {
		button: "Redigera"
	},
	reset: {
		button: "Återställ"
	},
	save: {
		button: "Spara"
	},
	share: {
		button: "Dela"
	}
};
var filter = {
	clear: "Återställ filter",
	clearAll: "Återställ alla filter"
};
var locationMap = {
	locationLink: {
		label: "Till platsen"
	}
};
var machineDiscontinuation = {
	linkText: "Läs mer"
};
var notifications = {
	button: {
		loadMore: "Ladda mer"
	},
	date: {
		lastMonth: "Förra månaden",
		lastWeek: "Förra veckan",
		older: "Äldre",
		thisMonth: "Denna månad",
		thisWeek: "Denna vecka",
		today: "Idag",
		yesterday: "Igår"
	},
	error: {
		general: "För närvarande kan inga notifikationer visas. Försök igen senare.",
		unauthorized: "Vänligen logga in för att se notifikationer"
	},
	info: {
		activateSettings: "För att ta emot notifikationer, aktivera dem i inställningarna",
		noNotification: "Det finns för närvarande inga meddelanden för dig."
	},
	title: "Notifieringar"
};
var results = {
	counter: {
		label: "träffar"
	}
};
var scrollToTop = {
	label: "Skrolla till toppen"
};
var slider = {
	nextButton: {
		label: "Nästa bild"
	},
	paginationBullet: {
		label: "Bild"
	},
	prevButton: {
		label: "Föregående bild"
	}
};
var sorting = {
	ascending: "Stigande",
	descending: "Sjunkande"
};
var userAccount = {
	address: {
		label: "Postadress"
	},
	email: {
		label: "E-post"
	},
	language: {
		label: "Språk",
		locale: "Lokal",
		select: "Välj språk",
		settings: "Språkinställningar"
	},
	loggedOut: {
		message: "Du är inte inloggad"
	},
	login: {
		button: "Logga in"
	},
	name: {
		label: "Namn"
	},
	phone: {
		label: "Telefon"
	}
};
var widget = {
	filter: {
		machine: {
			filter: "Filtrera maskiner",
			label: "Maskiner",
			option: {
				all: "Alla Maskiner"
			},
			select: "Välj maskin"
		},
		period: {
			label: "Period",
			option: {
				currentMonth: "Denna månad",
				currentWeek: "Denna vecka",
				lastMonth: "Förra månaden",
				lastWeek: "Förra veckan",
				today: "Idag",
				yesterday: "Igår"
			}
		}
	}
};
var widgetRegistry = {
	allWidgets: {
		label: "Mina widgets"
	},
	noDescriptionAvailable: "Ingen beskrivning tillgänglig.",
	widget: {
		SampleMyMachines: {
			title: "Mina Maskiner"
		},
		SampleMyServiceCalls: {
			title: "Serviceanrop"
		},
		SampleMyTrackingList: {
			title: "Spårningslista"
		},
		SampleMyUserAccount: {
			title: "Min profil"
		},
		SampleOperationalStatesChart: {
			title: "Drifttillstånd"
		},
		SampleWidgetFilter: {
			title: "Filterinställningar"
		},
		SampleWorkloadBalanceChart: {
			title: "Arbetsbelastningsbalans"
		}
	}
};
var translation = {
	app: app,
	contentLoadingError: contentLoadingError,
	dashboard: dashboard,
	filter: filter,
	locationMap: locationMap,
	machineDiscontinuation: machineDiscontinuation,
	notifications: notifications,
	results: results,
	scrollToTop: scrollToTop,
	slider: slider,
	sorting: sorting,
	userAccount: userAccount,
	widget: widget,
	widgetRegistry: widgetRegistry
};

export { app, contentLoadingError, dashboard, translation as default, filter, locationMap, machineDiscontinuation, notifications, results, scrollToTop, slider, sorting, userAccount, widget, widgetRegistry };

//# sourceMappingURL=translation17-f2af274a.js.map